export default "<style>\r\n\r\n  hidden--elements\r\n  {\r\n    display: none;\r\n  }\r\n\r\n</style>";